import { render } from "./AttivitaPreview.vue?vue&type=template&id=be309caa&scoped=true"
import script from "./AttivitaPreview.vue?vue&type=script&lang=js"
export * from "./AttivitaPreview.vue?vue&type=script&lang=js"

import "./AttivitaPreview.vue?vue&type=style&index=0&id=be309caa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be309caa"]])

export default __exports__